import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MUIListItem, { ListItemProps } from '@material-ui/core/ListItem';

// There seems to be a bug with mui's type definition, the api doc says button has a default value,
// but passing the prop in will result in a type error, for now, omitting it.
// Same with component, even tho
type Props = Omit<ListItemProps, 'button'>;

function ListItem({ classes, ...restOfProps }: Props) {
  const _classesOverride = useStyles();
  const classesOverride = !!classes ? classes : _classesOverride;

  return <MUIListItem classes={classesOverride} {...restOfProps} />;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    color: theme.colors.navText,
  },
}));

export default ListItem;
